import { honeybadger } from '../components/GlobalErrorBoundary/GlobalErrorBoundary';

import maskSubmittedParams from './obscurityHelper';

const notifyHoneybadger = (err, context = {}) => {
  const errorContext = {
    customerGuid: '',
    applicationId: '', // params, url, token
    ...maskSubmittedParams(context),
  };
  honeybadger.setContext(errorContext);
  honeybadger.notify(err);
};

// eslint-disable-next-line import/prefer-default-export
export { notifyHoneybadger };
